module.exports = __webpack_public_path__ + "img/lb3.8a78901a.jpg";